<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Tài xế
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const headers = [
  {
    field: 'fullName',
    headerName: $t('labels.name'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'haveLicense',
    headerName: 'Giấy phép lái xe',
    valueGetter: (params: any) => {
      const { haveLicense, license } = params.data
      if (haveLicense) {
        return 'Còn hạn'
      }

      if (license?.length) {
        return 'Hết hạn'
      }

      return 'Chưa có'
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'totalTrip',
    headerName: $t('labels.tripNumber'),
    valueGetter: (params: any) => {
      const { totalTrip } = params.data
      return $formatters.formatNumber(totalTrip || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'totalJourney',
    headerName: $t('labels.journeyNumber'),
    valueGetter: (params: any) => {
      const { totalJourney } = params.data
      return $formatters.formatNumber(totalJourney || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'totalKm',
    headerName: $t('labels.kmCount'),
    valueGetter: (params: any) => {
      const { totalKm } = params.data
      return $formatters.formatNumber(totalKm || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'totalSalaryDriver',
    headerName: $t('labels.totalSalary'),
    valueGetter: (params: any) => {
      const { totalSalaryDriver } = params.data

      if (typeof totalSalaryDriver !== 'number') {
        return ''
      }

      return $formatters.formatNumber(totalSalaryDriver || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'totalJourneyOntime',
    headerName: $t('labels.onTimeRate'),
    valueGetter: (params: any) => {
      const { totalJourneyOntime, totalJourney } = params.data
      if (!totalJourney) {
        return ''
      }
      return `${totalJourneyOntime}/${totalJourney}`
    }
  },
  {
    field: 'totalJourneyDriverActionAll',
    headerName: $t('labels.operationRate'),
    valueGetter: (params: any) => {
      const { totalJourneyDriverActionAll, totalJourney } = params.data
      if (!totalJourney) {
        return ''
      }
      return `${totalJourneyDriverActionAll}/${totalJourney}`
    }
  },
  {
    field: 'costsIncurred',
    headerName: $t('labels.costsIncurred'),
    valueGetter: (params: any) => {
      return '-'
      // const { costsIncurred } = params.data
      // return `${$formatters.formatNumber(costsIncurred || 0)} %`
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getDriver, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
